import { type QueryError } from './QueryError.types';

export const handleQueryErrorLogging = (error: QueryError) => {
    const status = error?.status;
    const eventPayload = {
        label: error.endpointPath,
        server_error: {
            path: error.endpointPath,
            status,
            message: error.data?.message,
        },
        fingerprint: error.endpointPath,
    };

    const ignorableErrors = [
        530, // cloudflare dns issue
    ];

    return {
        eventPayload,
        shouldNotify: !ignorableErrors.includes(status),
        errorForNotify: new Error(`Received status code ${status} in request to ${error.endpointPath}`),
    };
};
